(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .value('AppConfig', {
            MOIP_API_BASE_URL: "https://sandbox.moip.com.br/assinaturas",
            MOIP_ENCODE_64: 'Basic MzJNSzk2SURIWU1IQ0ZHM0VIUTNMT0ZZQVlGOVBTS0Y6RVRBUkw2QlNYRVVHWUhaRVFJU0U2UVdZNTBQM1JGTk5WWlRaNThFTQ=='
        });
})();
